/**
 * Truncate a string of text to a length specified
 * @param {number} length - the number of characters at which text should truncate
 * @param {string} input - the string of text
 * @returns {*}
 */
export const truncate = (input, length = 100) => {
  return input.length > length ? `${input.substring(0, length)}...` : input;
};
